'use client';

import { CONFIG } from '@frameio/config';
import { Analytics } from '@frameio/shared/components/Analytics';
import { isServer } from '@frameio/utils/config';

export const UserAnalytics = () => {
  // Set Intercom settings before loading Segment
  if (!isServer) {
    const appId = CONFIG.thirdParty.intercomAppId;
    window.intercomSettings = {
      app_id: appId,
      hide_default_launcher: true,
      custom_launcher_selector: '#intercom-launcher',
      fio_version: 4,
    };
  }
  /**
   * @todo (WEB-503): get feature flags enabled (specifically
   * `web.account_settings.restrict_data`) for a given Account. This is disabled
   * for now because client side feature flags are not fully compatible with the
   * app directory. We should get this flag from the server instead of the
   * client anyway. We can re-enable when this is a server-side feature flag,
   * which can be determined via the new hook/API like:
   *
   * const isRestricted = useFeatureFlagEnabled('web.account_settings.restrict_data');
   */
  return <Analytics isRestricted={false} />;
};
